export type CurrencySymbol = `A$` | `C$` | `£` | `$` | `€`

export type Currency = {
  code: string
  symbol: CurrencySymbol
}

const AUD: Currency = {
  code: `AUD`,
  symbol: `A$`
}

const CAD: Currency = {
  code: `CAD`,
  symbol: `C$`
}

const GBP: Currency = {
  code: `GBP`,
  symbol: `£`
}

const USD: Currency = {
  code: `USD`,
  symbol: `$`
}

const EUR: Currency = {
  code: `EUR`,
  symbol: `€`
}

export { GBP, USD, AUD, CAD, EUR }

const currenciesByCode: Record<string, Currency> = { AUD, CAD, EUR, GBP, USD }

export const currencyFromCode = (code: string): Currency => {
  const currency = currenciesByCode[code]
  if (!currency) {
    throw new Error(`Unknown currency code: ${code}`)
  } else {
    return currency
  }
}

export class Money {
  amount: number

  currency: Currency

  constructor(amount: number | string, currency: Currency) {
    this.amount = typeof amount === `string` ? parseFloat(amount) : amount
    this.currency = currency
  }

  public toString = () => `${this.currency.symbol}${this.amount.toFixed(2)}`

  public toStringNoDecimal = () =>
    `${this.currency.symbol}${this.amount.toFixed(2).replace(`.00`, ``)}`
}
